var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusStopSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M758.3 266.2h188.5v216.5H758.3z",
    fill: "#FFB819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M862 345.9m-40.5 0a40.5 40.5 0 1 0 81 0 40.5 40.5 0 1 0-81 0Z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.4 242.6h638v240.1h-638z",
    fill: "#00B3E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7 246.5h43.4v541.9H98.7z",
    fill: "#333E48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7 246.5h43.4V310H98.7z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M416.2 246.5h43.4v236.2h-43.4z",
    fill: "#333E48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142 266.2h591.7v54.7H142z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M733.8 246.5h43.4v541.9h-43.4z",
    fill: "#333E48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M733.8 246.5h43.4V310h-43.4z",
    fill: ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 689h37.5v99.4h-37.5z",
    fill: "#A4A9AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 767.3h37.5v21.1h-37.5z",
    fill: ""
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M609.6 689h37.5v99.4h-37.5z",
    fill: "#A4A9AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M609.6 767.3h37.5v21.1h-37.5z",
    fill: ""
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M673.3 662v-93.5c0-17.9-14.7-32.6-32.6-32.6H235.2c-17.9 0-32.6 14.7-32.6 32.6V662h470.7z",
    fill: "#A4A9AD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437.9 575.5m-10.6 0a10.6 10.6 0 1 0 21.2 0 10.6 10.6 0 1 0-21.2 0Z",
    fill: ""
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M361.3 575.5m-10.6 0a10.6 10.6 0 1 0 21.2 0 10.6 10.6 0 1 0-21.2 0Z",
    fill: ""
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M284.7 575.5m-10.6 0a10.6 10.6 0 1 0 21.2 0 10.6 10.6 0 1 0-21.2 0Z",
    fill: ""
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M514.5 575.5m-10.6 0a10.6 10.6 0 1 0 21.2 0 10.6 10.6 0 1 0-21.2 0Z",
    fill: ""
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M591.1 575.5m-10.6 0a10.6 10.6 0 1 0 21.2 0 10.6 10.6 0 1 0-21.2 0Z",
    fill: ""
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.6 609.7h470.7V662H202.6z",
    fill: ""
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M673.3 695.4H202.6c-18.5 0-33.4-15-33.4-33.4 0-18.5 15-33.4 33.4-33.4h470.7c18.5 0 33.4 15 33.4 33.4s-15 33.4-33.4 33.4z",
    fill: "#D1D3D3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 223.8c0-11-9-20-20-20H95.3c-11 0-20 9-20 20v22.4c0 11 9 20 20 20h685.2c11 0 20-9 20-20v-22.4z",
    fill: "#0071CE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M905.5 442h-87.1c-8 0-14.5-6.5-14.5-14.5s6.5-14.5 14.5-14.5h87.1c8 0 14.5 6.5 14.5 14.5s-6.5 14.5-14.5 14.5z",
    fill: "#FFFFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M959.4 820.4c0 4.2-3.5 7.7-7.7 7.7H70.4c-4.3 0-7.7-3.5-7.7-7.7v-27.7c0-4.3 3.5-7.7 7.7-7.7h881.2c4.3 0 7.7 3.5 7.7 7.7l0.1 27.7z",
    fill: "#A4A9AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusStopSvgrepoCom);
export default __webpack_public_path__ + "static/media/bus-stop-svgrepo-com.f76924fefae92172cfc85ca78eed7998.svg";
export { ForwardRef as ReactComponent };